export const nb = {
  meta: {
    appName: 'SmartOslo',
    locale: 'nb-NO',
  },
  common: {
    close: 'Lukk',
    next: 'Neste',
    previous: 'Forrige',
    saveAndClose: 'Lagre og lukk',
    edit: 'Rediger',
    share: 'Del',
    shared: 'Delt',
    openInNewWindow: 'Åpne i nytt vindu',
    notProvided: 'Ikke oppgitt',
    unknownDate: 'Dato ukjent',
  },
  header: {
    logoAlt: 'Oslo kommune',
    osloLabel: 'Oslo',
    searchPlaceholder: 'Søk i hele nettstedet',
    searchAriaLabel: 'Søk i hele nettstedet',
    searchButtonAriaLabel: 'Søk',
    menu: 'Meny',
    contact: 'Kontakt',
    application: 'Søknad',
    dashboard: 'Dashboard',
  },
  stepper: {
    ariaLabel: 'Søknadssteg',
    municipalityOwner: 'Kommune',
    partnerOwner: 'Partner',
  },
  stepNavigation: {
    previous: 'Forrige',
    next: 'Neste',
    submit: 'Send søknad',
  },
  applicationSteps: {
    1: 'Om prosjektet',
    2: 'Støtte & vedlegg',
    3: 'Seriøsitetsbevis',
    4: 'Oppsummering',
  },
  roleSwitcher: {
    actingAs: 'Du opptrer som',
    municipalityName: 'Oslo kommune',
    partnerFallback: 'GreenLoop Labs',
    wallet: 'Lommebok',
    walletSwitchAriaLabel: 'Bytt mellom Symfoni og mock-lommebok',
    resetDemo: 'Nullstill demo',
    switchToPartner: 'Bytt til {partnerName}',
    switchToMunicipality: 'Bytt til {municipalityName}',
  },
  englishPlaceholder: {
    title: 'Smart Oslo (English)',
    body: 'English variant scaffold is ready for task 4-7.',
  },
  dashboard: {
    title: 'Totaloversikt underleverandører',
    statsTotalLabel: 'Totalt antall',
    statsApprovedLabel: 'Godkjent (lav risiko)',
    statsApprovedSubLabel: 'Score > 75%',
    statsFollowupLabel: 'Krever oppfølging',
    statsFollowupSubLabel: 'Score 50-74%',
    statsRiskLabel: 'Høy risiko / avvik',
    statsRiskSubLabel: 'Handlinger påkrevd',
    liveMonitoring: 'Live monitorering aktiv',
  },
  statusBadge: {
    ok: 'OK',
    review: 'Sjekk detaljer',
    critical: 'Kritisk',
  },
  projectTable: {
    empty: 'Ingen prosjekter funnet',
    project: 'Prosjekt',
    partner: 'Samarbeidspartner',
    riskScore: 'Sanntids risikoscore',
    status: 'Status',
    detailsAria: 'Vis detaljer for {projectName}',
  },
  riskChart: {
    title: 'Risikofordeling - sanntid',
    ariaLabel: 'Risikofordeling: {ok} godkjent, {review} krever oppfølging, {critical} kritisk',
    averageTrust: 'Snitt tillit',
    noDeviation: 'Ingen avvik',
    reviewDetails: 'Obs! Sjekk detaljer',
    criticalStop: 'Kritisk / Stopp',
  },
  projectDetail: {
    totalRiskScore: 'Total Risikoscore',
    atomicCredentials: 'Atomic Credentials (Mikrobevis)',
    realtimeObject: 'Sanntidsobjekt',
    dynamicPolicyLogic: 'Dynamic Policy Logic',
    totalCalculated: 'Total Kalkulert',
    simulatorTitle: 'Simulator (Continuous Vetting)',
    simulatorDescription:
      'Simuler en hendelse fra en utsteder (f.eks. Skatteetaten) for å se hvordan risikoscoren oppdateres umiddelbart.',
    simulatorAction: 'SIMULER:',
    simulatorChangeStatus: '(Endre status)',
    simulatorSelectHint:
      'Klikk på et bevis til venstre for å velge det, deretter klikk SIMULER for å endre status.',
    applicationDate: 'Søknadsdato: {date}',
    updatedDate: 'Sist oppdatert: {date}',
    block: '(BLOCK)',
    ok: '(OK)',
  },
  modalCredentialCard: {
    issuer: 'Utsteder: {issuer} • {date}',
    lastEventManualRevoked: 'Siste hendelse: Manuelt revokert (simulering)',
    lastEvent: 'Siste hendelse: {reason}',
    lastEventInvalid: 'Siste hendelse: Bevis ugyldig',
    validStatus: 'GYLDIG / OK',
    invalidStatus: 'UGYLDIG / REVOKERT',
  },
  circularProgress: {
    scoreAriaLabel: '{percentage}% score',
  },
  partnerInbox: {
    title: 'Ny forespørsel fra Oslo kommune',
    intro:
      'Oslo kommune har startet en SmartOslo-søknad med {partnerName} (org.nr {orgnr}) som samarbeidspartner.',
    projectTitle: 'Prosjekttittel: {title}',
    whatToDo: 'Hva må du gjøre?',
    task1: 'Fyll ut informasjon om støtte og last opp vedlegg',
    task2: 'Del seriøsitetsbevis fra din virksomhetslommebok',
    task3: 'Send tilbake til Oslo kommune for gjennomgang',
    start: 'Start utfylling',
    partnerFallback: 'GreenLoop Labs',
    orgFallback: 'Ikke oppgitt',
    projectFallback: '(Ikke oppgitt)',
  },
  step1: {
    loginMethodTitle: 'Velg innloggingsmetode',
    walletAlt: 'Digital lommebok',
    walletTitle: 'Digital lommebok',
    walletSubtitle: 'Med din digitale lommebok',
    processingLogin: 'Behandler delt data...',
    entraAlt: 'Microsoft Entra ID',
    entraTitle: 'Microsoft Entra',
    entraSubtitle: 'Organisasjonsinnlogging',
    loggedInAs: 'Innlogget som: {name}',
    title: 'SmartOslo-ordningen',
    infoText:
      'Her kan du søke om støtte til å gjennomføre test og demonstrasjonsprosjekter som potensielt løser et problem for Oslo kommune. Være klar over at denne søknaden vil kunne bli offentlig tilgjengelig i etterkant av innsendelse. Det bør derfor ikke fremkomme markedsensitiv informasjon eller forretningsideer som ikke kan deles med offentligheten.',
    applyingAs:
      'Du søker på vegne av {city}, basert på ansattkortet du delte ved innlogging.',
    applyForAnotherLabel: 'Søk på vegne av en annen virksomhet',
    applyForAnotherHint: 'Velg virksomhet her hvis du ikke søker for din egen enhet.',
    selectUnitPlaceholder: 'Velg enhet',
    projectTitleLabel: 'Prosjekttittel',
    projectTitlePlaceholder: 'Bruk midlertidig navn dersom prosjektet ikke har et endelig navn',
    descriptionLabel: 'Hva ønsker dere å teste / gjøre i dette prosjektet?',
    descriptionPlaceholder:
      'Beskriv kort hva dere ønsker å gjøre og hvordan det skal bidra til å løse problemet',
    problemLabel: 'Hvilket problem for Oslo kommune ønsker dere å løse?',
    problemPlaceholder: 'Beskriv problemet dere ønsker å løse',
    areasLabel: 'Innen hvilket område vil prosjektet ha virkning?',
    partnerSectionLabel: 'Samarbeidspartner',
    partnerSectionHint: 'Oppgi organisasjonsnummeret til din samarbeidspartner.',
    partnerAdded: 'Samarbeidspartner lagt til',
    partnerName: 'Navn: {name}',
    partnerCountry: 'Land: {country}',
    partnerOrgnr: 'Org.nr: {orgnr}',
    partnerCountryLabel: 'Partnerland',
    partnerCountryPlaceholder: 'Velg land',
    partnerCountryHint: 'Velg landet partneren er registrert i.',
    partnerIdentifierPlaceholder: 'Partneridentifikator',
    partnerIdentifierHint: 'Bruk identifikatoren partneren er registrert med.',
    orgnrPlaceholder: '9-sifret organisasjonsnummer',
    orgnrHint: 'Organisasjonsnummer må være nøyaktig 9 siffer',
    fetchingBrreg: 'Henter virksomhetsnavn fra Brreg...',
    sentToPartnerTitle: 'Sendt til samarbeidspartner',
    sentToPartnerDescription:
      'Venter på at samarbeidspartner fyller ut seriøsitetsbevis og støtteinformasjon.',
    sendToPartner: 'Send til samarbeidspartner',
    brregError: 'Kunne ikke hente virksomhetsnavn fra Brreg',
    fallbackPartnerName: 'GreenLoop Labs {orgnr}',
    eAidCountriesError: 'Kunne ikke laste land fra eAidRegister',
  },
  step2: {
    title: 'Støtte & vedlegg',
    waitingTitle: 'Venter på samarbeidspartner',
    waitingBody:
      'Denne delen av søknaden skal fylles ut av samarbeidspartneren {partnerName}{orgSuffix}. Du vil kunne se innholdet når partneren har fullført sin del og sendt søknaden tilbake.',
    attachmentsLabel: 'Vedlegg',
    completedTitle: 'Din del er fullført',
    completedBody: 'Bytt til Oslo kommune for å gjennomgå og fullføre søknaden.',
  },
  step3: {
    title: 'Seriøsitetsbevis',
    fallbackError: 'Noe gikk galt under innhenting fra virksomhetslommeboken.',
    failureFallback: 'Deling fra virksomhetslommebok ble avvist eller feilet.',
    cancelled: 'Avbrutt',
    invalidExpiry: 'Mottok ugyldig utløpstid fra virksomhetslommeboken.',
    timeout: 'Deling tok for lang tid. Avbryt og prøv på nytt.',
    expired: 'Forespørselen utløp før deling ble fullført. Prøv på nytt.',
    selectAtLeastOne: 'Velg minst ett bevis før du henter fra virksomhetslommebok.',
    noSharedProofs: 'Ingen gjenkjente bevis ble delt tilbake fra virksomhetslommebok.',
    creatingRequest: 'Oppretter forespørsel...',
    simulatingShare: 'Simulerer deling...',
    waitingForShare: 'Venter på deling...',
    fetchFromWallet: 'Hent fra virksomhetslommebok',
    showMockWallet: 'Vis mock-lommebok',
    fetchFromMockWallet: 'Hent fra mock-lommebok',
    cancel: 'Avbryt',
    hintSymfoni:
      'Velg ett eller flere bevis, trykk Hent fra virksomhetslommebok, og fullfør deling i Symfoni-appen.',
    hintMock:
      'Trykk Hent fra mock-lommebok for å åpne popup og dele bevis ett og ett. Søknaden oppdateres fortløpende.',
    hintReadonly:
      'Alle tilgjengelige bevis vises under. Deling utføres av samarbeidspartner i virksomhetslommeboken.',
    waitingPartnerTitle: 'Venter på samarbeidspartner',
    waitingPartnerBody:
      'Når partneren har delt bevis fra virksomhetslommeboken, oppdateres score og status automatisk.',
    popupBlockedTitle: 'Popup ble blokkert',
    popupBlockedBody: 'Tillat popup-vinduer i nettleseren din for å bruke mock-lommeboken.',
    waitingConsentTitle: 'Venter på samtykke i Symfoni',
    waitingConsentBody:
      'Åpne lommeboken, velg Del, og gå tilbake hit. Vi sjekker status automatisk hvert 1-2 sekund.',
    requestId: 'Request ID: {id}',
    manualOpenTitle: 'Kunne ikke åpne lommebok automatisk',
    manualOpenBody: 'Nettleseren blokkerte nytt vindu. Åpne lenken manuelt for å fullføre deling:',
    openSymfoniRequest: 'Åpne Symfoni-forespørsel',
    walletErrorTitle: 'Kunne ikke hente bevis',
    receivedFrom: 'Bevis mottatt fra {source}',
    lastUpdated: 'Sist oppdatert: {date}',
    noProofsReceived: 'Ingen bevis mottatt',
    noProofsSharedYet: 'Ingen bevis delt ennå',
    noProofsReceivedBody: 'Samarbeidspartner har ikke delt noen bevis fra lommeboken ennå.',
    noProofsSharedYetBody:
      'Åpne mock-lommeboken og del bevis ett og ett. Oversikten oppdateres fortløpende.',
    selectedProofs: 'Valgte bevis',
    selectedCount: '{count} valgt',
    selectedNone: 'Ingen valgt ennå',
    sharedCount: '{count} delt',
    sharedNone: 'Ingen delt ennå',
    partnerLookupTitle: 'Partner slått opp på organisasjonsnummer',
    orgnrLabel: 'Org.nr:',
    nameLabel: 'Navn:',
    contactLabel: 'Kontakt:',
    emailLabel: 'E-post:',
    completedTitle: 'Din del er fullført',
    completedBody: 'Bytt til Oslo kommune for å gjennomgå og fullføre søknaden.',
    sendBack: 'Fullfør og send tilbake',
    sentFromWalletLabel: 'virksomhetslommebok',
    sentFromMockWalletLabel: 'mock-lommebok',
  },
  step4: {
    submittedTitle: 'Søknad sendt!',
    submittedBody:
      'Din søknad er mottatt og vil bli behandlet. Du vil motta en bekreftelse på e-post.',
    referenceNumber: 'Referansenummer: {reference}',
    title: 'Oppsummering & egenerklæring',
    projectInfo: 'Prosjektinformasjon',
    projectName: 'Prosjektnavn:',
    projectCity: 'By:',
    company: 'Virksomhet:',
    areas: 'Områder:',
    requestedGrant: 'Tilskudd fra SmartOslo:',
    partner: 'Samarbeidspartner',
    partnerOrg: 'Org.nr:',
    contactPerson: 'Kontaktperson:',
    support: 'Støtte',
    deMinimisExceeded: 'Bagatellmessig støtte kan bli overskredet',
    supportCheckRequired: 'Støttekontrollen kunne ikke fullføres. Prøv igjen før innsending.',
    retrySupportCheck: 'Prøv støttekontrollen igjen',
    deMinimisQualified: 'Samarbeidspartner er kvalifisert for bagatellmessig støtte',
    previousSupport: 'Tidligere støtte (3 år):',
    totalWithGrant: 'Sum med tilskudd:',
    limit: 'Grense:',
    agreementSigning: 'Signering av samarbeidsavtale',
    signedByPartner: 'Signert av {partnerName} (org.nr {orgnr})',
    partnerNotSigned: 'Partneren har ikke signert samarbeidsavtalen ennå',
    warningTitle: 'Samarbeidsavtalen er ikke signert av Oslo kommune',
    warningBody:
      'Du kan fortsatt sende inn søknaden, men vi anbefaler å signere avtalen først.',
    goBackAndSign: 'Gå tilbake og signer',
    submitAnyway: 'Send inn likevel',
    budgetAndCosts: 'Budsjett og kostnadsplan',
    declarationsTitle: 'Egenerklæring – Oslo kommune',
    submitApplication: 'Send søknad',
    municipalityAgreementFileContext: 'Oslo kommune',
    partnerAgreementFileContext: 'samarbeidspartneren',
  },
  walletPopup: {
    title: 'Symfoni virksomhetslommebok',
    subtitle: 'Digital virksomhetslommebok',
    intro: 'Velg hvilke bevis du vil dele med søknaden. Trykk "Del" for å sende beviset.',
    points: '{points} pts',
    footer: 'Symfoni virksomhetslommebok',
  },
  personalWalletPopup: {
    title: 'Symfoni ID',
    subtitle: 'Personlommebok',
    intro: 'Del ansattkortet ditt fra Symfoni ID for å logge inn.',
    cardTitle: 'Ansattkort',
    cardType: 'Kommunalt ansattkort',
    name: 'Navn:',
    department: 'Avdeling:',
    section: 'Seksjon:',
    employeeNumber: 'Ansattnr:',
    issuedBy: 'Utstedt av: Oslo kommune',
    issuedAtLabel: 'Utstedt:',
    issuedAtValue: '15.08.2023',
    footer: 'Symfoni ID personlommebok',
  },
  signingPopup: {
    title: 'Signer dokument',
    subtitle: 'Digital virksomhetslommebok',
    step1Body: 'Du har mottatt et dokument for signering.',
    fileAlt: 'Word-dokument',
    fileName: 'Samarbeidsavtale.docx',
    fileType: 'Microsoft Word-dokument',
    viewDocument: 'Se dokument',
    signBody: 'Du signerer dokumentet digitalt med din virksomhetslommebok.',
    signDocument: 'Signer dokument',
    signed: 'Dokumentet er signert',
    contextLabel: 'samarbeidspartneren',
  },
  kommuneSigningPopup: {
    title: 'Signer dokument',
    subtitle: 'Digital lommebok – Oslo kommune',
    step1Body: 'Du har mottatt et dokument for kontrasignering.',
    fileAlt: 'Word-dokument',
    fileName: 'Samarbeidsavtale.docx',
    fileType: 'Microsoft Word-dokument',
    viewDocument: 'Se dokument',
    partnerSigned: 'Allerede signert av partner',
    signBody: 'Du signerer på vegne av Oslo kommune (org.nr 958 935 420).',
    signDocument: 'Signer dokument',
    signed: 'Dokumentet er signert',
    contextLabel: 'Oslo kommune',
  },
  agreementDocumentDialog: {
    title: 'Samarbeidsavtale mellom virksomhet og støttemottaker',
    fileName: 'Avtale-mellom-virksomhet-og-stottemottaker-Innovasjonsprosjekt.pdf',
    dialogTitle: 'Se samarbeidsavtalen',
    descriptionWithContext: 'Dette er avtalen som skal signeres av {contextLabel}.',
    descriptionDefault: 'Dette er avtalen som skal signeres.',
    fallbackInfo: 'Hvis dokumentet ikke vises, kan du åpne det i et nytt vindu.',
  },
  agreementSigning: {
    documentName: 'Samarbeidsavtale.docx',
    signedAt: 'Signert {timestamp}',
    sectionLabel: 'Samarbeidsavtale',
    signButton: 'Signer samarbeidsavtale',
    fileAlt: 'Word-dokument',
  },
  budgetButton: {
    title: 'Budsjett og kostnadsplan',
    fileAlt: 'Budsjett',
    totalCost: 'Totalkostnad: {amount}',
    balanceOk: ' · Balanse: OK',
    balanceDeviation: ' · Balanse: Avvik',
    filledAt: ' · Fylt ut {timestamp}',
    fillButton: 'Fyll ut budsjett',
  },
  budgetDialog: {
    title: 'Budsjett og kostnadsplan',
    partnerDescription: 'Fyll ut prosjektkostnader og/eller egenandel for din organisasjon.',
    municipalityDescription: 'Fyll ut finansieringsplan og prosjektkostnader for kommunen.',
    financingPlan: 'Finansieringsplan',
    contributionSummary: 'Beregnet egenandel',
    post: 'Post',
    amountNok: 'Beløp (kr)',
    percentOfTotal: '% av total',
    totalCost: 'Totalkostnad',
    totalFinancing: 'Total finansiering',
    partnerContribution: 'Egenandel fra samarbeidspartner',
    municipalityContribution: 'Egenandel fra kommunal virksomhet',
    totalContribution: 'Sum egenandel',
    partnerContributionIntro:
      'Prosjektet krever minst 50 % egenandel. Fyll inn prosjektkostnadene her, slik at bidraget deres kan beregnes.',
    municipalityContributionIntro:
      'Prosjektet krever minst 50 % egenandel. Fyll inn kommunens prosjektkostnader her, slik at kommunens bidrag kan beregnes.',
    partnerTotalExpenses: 'Deres totale prosjektkostnader',
    municipalityTotalExpenses: 'Kommunens totale prosjektkostnader',
    partnerContributionSummaryText:
      'Dette er deres totale kostnader i prosjektet. De teller som deres bidrag sammen med kommunens andel for å oppfylle kravet om minst 50 % egenandel.',
    municipalityContributionSummaryText:
      'Dette er kommunens totale kostnader i prosjektet. De teller som kommunens bidrag sammen med partnerens andel for å oppfylle kravet om minst 50 % egenandel.',
    requestedGrant: 'Ønsket tilskudd fra SmartOslo',
    amountLockedHint: 'Beløpet blir låst for kommunen i oppsummeringen.',
    contributionThresholdError: 'Egenandelen må være minst 50% av total finansiering',
    applicantProjectCosts: 'Prosjektkostnader søker (kommunal virksomhet)',
    partnerProjectCosts: 'Prosjektkostnader samarbeidspartner',
    projectResult: 'Prosjektresultat',
    totalFinancingLabel: 'Total finansiering:',
    totalCostsLabel: 'Total kostnader:',
    differenceLabel: 'Differanse:',
    balanced: 'Budsjettet er i balanse',
    unbalanced: 'Budsjettet er ikke i balanse (differanse: {amount})',
  },
  deMinimis: {
    checking: 'Sjekker støtteregisteret...',
    qualifiedUpTo:
      'Din samarbeidspartner er kvalifisert til å motta bagatellmessig støtte opptil {amount}',
    noHitsAssumption:
      'Støtteregisteret gir ingen treff nå, og vi legger til grunn at partneren kan motta beløpet.',
    verificationUnavailable: 'Automatisk kvalifiseringssjekk er utilgjengelig',
    verificationUnavailableBody:
      'Vi kunne ikke verifisere partneren i støtteregisteret akkurat nå. Åpne eAidRegister for å bekrefte partneren før dere går videre.',
    mayExceed: 'Bagatellmessig støtte kan bli overskredet',
    exceedBody:
      'Med et tilskudd på {requested} vil samlet støtte overstige grensen på {limit} i en rullerende 3-årsperiode.',
    previousSupport: 'Tidligere tildelt støtte (siste 3 år):',
    plannedSupport: 'Planlagt støtte (fast):',
    sum: 'Sum:',
    limit: 'Grense:',
    basedOnHistory: 'Basert på registrerte tildelinger de siste 3 årene.',
    eAidRegisterHint: 'Søk på organisasjonsnummer {orgnr} i EU sitt eAidRegister for en live verifisering.',
    openEaidRegister: 'Åpne eAidRegister',
  },
  eAidDeMinimis: {
    checking: 'Sjekker eAidRegister...',
    eligible: 'Partneren ser ut til å være kvalifisert for ytterligere bagatellmessig støtte',
    mayExceed: 'Partneren kan overstige EUs de minimis-grense',
    basedOnRegister: 'Basert på bagatellmessige tildelinger registrert i eAidRegister de siste 3 årene.',
    noRecordedAidBody: 'Det ble ikke funnet bagatellmessige tildelinger i eAidRegister for denne identifikatoren de siste 3 årene.',
    verificationUnavailable: 'Kunne ikke verifisere mot eAidRegister',
    verificationUnavailableBody:
      'EU-registeret kunne ikke spørres akkurat nå. Åpne eAidRegister for å verifisere partneren manuelt.',
    matchedPartner: 'Treff på partner:',
    country: 'Land:',
    identifier: 'Identifikator:',
    registeredAid: 'Registrert støtte siste 3 år:',
    plannedAidApprox: 'Planlagt støtte (omtrentlig):',
    sum: 'Sum:',
    limit: 'EU-grense:',
    openRegister: 'Åpne eAidRegister',
  },
  trustScorePanel: {
    title: 'Total Trust Score',
    updatedAt: 'Oppdatert: {time}',
    approved: 'Godkjent',
    thresholdLabel: 'Terskel for kontrakt:',
    points: '{points} Poeng',
    sliderHint: 'Du bestemmer kravene. Juster slideren.',
    howItWorksTitle: 'Hvordan det fungerer',
    howItWorksParagraph1:
      'Tillitsscoren bygger på en negativ tillitsmodell: i stedet for å lete etter grunner til å stole på søkeren, verifiserer vi at det ikke finnes varsellamper i offentlige registre.',
    howItWorksParagraph2:
      'Hver verifisering som er i orden gir poeng. Scoren oppdateres automatisk – faller en verifisering bort, for eksempel ved manglende skatteinnbetaling, synker scoren umiddelbart.',
    pointsLabel: 'Poeng',
  },
  trustScoreDisplay: {
    compactOk: 'OK',
    compactBelow: 'Under terskel',
    title: 'Seriøsitetsscore',
    points: 'poeng',
    progressAriaLabel: 'Seriøsitetsscore',
    thresholdLabel: 'Terskel: {threshold}',
    approvedStatus: 'GODKJENT - Score over terskel',
    belowStatus: 'UNDER TERSKEL - Bør følges opp',
  },
  credentialPanel: {
    points: '{points} pts',
    sharedFrom: 'Delt fra {source}',
    required: 'Obligatorisk',
    notSharedYet: 'Ikke delt ennå',
  },
  fileUploadButton: {
    upload: 'Last opp',
    inactiveDemo: '(Ikke aktiv i demo)',
  },
  domain: {
    costLabels: {
      lonn: 'Lønn',
      eksterneTjenester: 'Eksterne tjenester',
      utstyrOgMaterialer: 'Utstyr og materialer',
      reiseOgMoter: 'Reise og møter',
      kommunikasjon: 'Kommunikasjon',
      andreUtgifter: 'Andre utgifter',
    },
    sourceIssuerLabels: {
      oid: 'Organisasjon',
      brreg: 'Brønnøysundregistrene',
      skatteetaten: 'Skatteetaten',
      bank: 'Bank & Finans',
      tilsyn: 'Tilsynsmyndighet',
    },
    sourceCategoryLabels: {
      oid: 'Identifikasjon',
      brreg: 'Foretaksregistrering',
      skatteetaten: 'Skatteattest',
      bank: 'Kreditrating',
      tilsyn: 'HMS/Tilsyn',
    },
    declarations: [
      'Jeg er klar over at denne søknaden kan bli offentlig tilgjengelig i etterkant.',
      'Jeg bekrefter at det ikke fremkommer forretningshemmeligheter eller annen sensitiv informasjon som ikke kan offentliggjøres.',
      'Jeg har lest og forstått retningslinjene for bruk av SmartOslo-midlene.',
    ],
  },
} as const;

export type NbMessages = typeof nb;
